import { configRolesUsers } from '../../../config/permissions';

const Options = (user) => {
    const roleUser = user?.roleId || 1;
    return configRolesUsers[roleUser].options
} ;

    export default Options; 